module.exports = __webpack_public_path__ + "static/img/9.00b0ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/9.jpg
// module id = danH
// module chunks = 2